const LOCALSTORAGE_KEY = 'calculator';
const RESET_MUTATION = 'reset';

const PersistancePlugin = store => {
	const persistedState = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY));

	// Commit persisted state
	if (persistedState) {
		store.replaceState(persistedState);

		// Apply possible calculation updates
		store.commit('updateSharesFromConfigurator');
	}

	// Update or reset persisted state
	store.subscribe((mutation, state) => {
		if (mutation.type === RESET_MUTATION) {
			localStorage.removeItem(LOCALSTORAGE_KEY);
		} else {
			localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(state));
		}
	});
};

export default PersistancePlugin;
